import '../styles/footer.css';


const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="ry-footer" role="contentinfo">
      <div className="ry-footer__inner">
        <p className="ry-footer__copy">
          © {year} ReYou. Alle Rechte vorbehalten.
        </p>

        <nav className="ry-footer__nav" aria-label="Footernavigation">
          {/* Tausche hrefs gegen deine Routes */}
          <a href="/agb">AGB</a>
          <a href="/privacy">Datenschutz</a>
          <a href="/impressum">Impressum</a>
          <a href="/impressum">Kontakt</a>
          <a href="https://instagram.com/reyou" target="_blank" rel="noreferrer">
            Instagram
          </a>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
